<div class="container-fluid main-cont webview fontFOCO">
    <div class="row height-auto">

        <!--  -->
        <div class="col-12" style="display: flex; justify-content: flex-start;padding-left: 5%; align-items: center;"
            *ngIf="isVideoOpen">

            <div class="display-6" style="cursor: pointer;">
                <i class="fa fa-arrow-left" (click)="backBtn()"></i>
            </div>
            <div style="margin-left: 7%;">
                <h1 class="display-6" style="text-align: left;">
                    DISCOVER OUR LATEST <span class="pink-color">REELS!</span>
                </h1>
            </div>

        </div>
        <!--  -->

        <!--  -->
        <div *ngIf="!isVideoOpen" class="col-6 col-md-6 col-lg-6 brdr height-auto">
            <div class="col-md-12 text-center d1">
                <h1 class="display-6 ">DISCOVER OUR <br>
                    LATEST <span class="pink-color">REELS!</span>
                </h1>
            </div>

            <div class="col-md-12 pt-4 d5">
                <img class="bline" src="../../../../assets/pmbReelsFile/blackLineIcn.svg">
            </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="col-md-5 xpdv1" *ngIf="isVideoOpen">
            <div class="xpdv2">
                <ng-container *ngFor="let item of assetArray">
                    <video *ngIf="selected == item.id && !isToggle" controls="controls" autoplay muted class="vd1"
                        [title]="item?.videoDescription">
                        <source [src]="item.url" type="video/mp4">
                    </video>

                    <div *ngIf="selected == item.id && !isToggle"
                        style="position: absolute; bottom: 15%; left: 10%;cursor: pointer; " (click)="toggleDownUp()">
                        <img style="rotate: 90deg;" src="../../../../assets/pmbReelsFile/navRIcn.svg" [alt]="item.alt">
                        &nbsp;
                        &nbsp;
                        <span style="color: #ff0066;">Read more...</span>
                    </div>

                    <div class="vd1 brdr th11" *ngIf="selected == item.id && isToggle">
                        <div style="display: flex;justify-content: space-between;align-items: center;padding: 10px;">
                            <h3>{{item.title}}</h3>
                            <img (click)="toggleDownUp()" src="../../../../assets/pmbReelsFile/navLIcn.svg"
                                [alt]="item.alt" class="tgDU">
                        </div>

                        <div style="font-size: 16px;padding: 10px;" [innerHTML]="item.description"> </div>
                    </div>

                </ng-container>
            </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="col-6 col-md-6 col-lg-6 brdr" style="height: 100%;position: relative;">
            <div class="dv8" id="vCont">
                <div *ngFor="let item of assetArray" class="dv9">

                    <!-- description  -->
                    <div *ngIf="toggle == item?.id" class="th11">

                        <div style="display: flex;justify-content: space-between;align-items: center;padding: 10px;">
                            <h3>{{item.title}}</h3>
                            <img (click)="toggleShowDiv()" src="../../../../assets/pmbReelsFile/navLIcn.svg"
                                style="border: 2px solid #ffc107; padding: 10px 15px; background-color: #413f3f; margin-top: -10px;">
                        </div>

                        <div style="font-size: 16px;padding: 10px;" [innerHTML]="item.description"> </div>
                    </div>
                    <!-- description  -->

                    <!-- item  -->
                    <img *ngIf="toggle != item.id && selected != item?.id" (click)="openVideo(item?.id,item?.weburl)"
                        class="th1" [src]="item.thumbnail" [id]="item.id" [alt]="item.alt">

                    <div class="row dv12" *ngIf="toggle != item.id && selected != item?.id">
                        <div class="col-md-7" (click)="openDescription()">
                            <div (click)="toggleShowDiv(item.id)"
                                style="color: #f8f9fa;; font-size: 13px; font-weight: 500;">
                                <span> <i class="fa fa-angle-up" style="font-size: 1rem;"></i> &nbsp; </span>
                                Exporting Benefits
                            </div>
                        </div>
                        <div class="col-md-5 dv13">
                            <div class="dv5">
                                <img class="dv6" src="../../../../assets/pmbReelsFile/shareIcn.svg" data-toggle="modal"
                                    (click)="share(item)" data-target="#shareModal">
                            </div>
                            <div class="dv4" (click)="scrollFunction('plus')">
                                <img class="" src="../../../../assets/pmbReelsFile/navRIcn.svg">
                            </div>
                        </div>
                    </div>
                    <!-- item  -->
                </div>
            </div>

            <div style="position: absolute; left: 2%; bottom: 1%;">
                <div style="position: relative;">
                    <img class="l1" src="../../../../assets/pmbReelsFile/redLineIcn1.svg">
                    <img class="l3" src="../../../../assets/pmbReelsFile/redLineIcn2.svg">
                    <img class="l2" src="../../../../assets/pmbReelsFile/redLineIcn3.svg">
                </div>
            </div>
            <!--  -->

            <!--  -->
            <div class="dv10 brdr">
                <div
                    style="text-align:center;display: flex;justify-content: space-evenly;align-items: center;margin-left:25%;">
                    <div *ngFor="let a of assetArray; let i = index">
                        <span *ngIf="(i+1) != elementId" (click)="scrollFunction('eq',i+1)" class="dot"
                            style="cursor: pointer;"></span>
                        <span *ngIf="(i+1) == elementId" class="capsule"></span>
                    </div>
                </div>

                <div style="margin-right: 7%;display: flex;">
                    <button id="slideLeft" class="bt" (click)="scrollFunction('minus')"><i class="fa fa-angle-left"
                            aria-hidden="true"></i></button>
                    <button id="slideRight" class="bt" (click)="scrollFunction('plus')"><i class="fa fa-angle-right"
                            aria-hidden="true"></i></button>
                </div>
            </div>
            <!--  -->

        </div>
        <!--  -->

    </div>
</div>

<!-- mobile view -->
<div class="container-fluid mobileview fontFOCO" style="height: 100vh;">
    <!--  -->
    <div class="col-12" style="display: flex; justify-content: flex-start;padding-left: 5%; align-items: center;">

        <!-- <div class="display-6" style="cursor: pointer;">
            <i class="fa fa-arrow-left" (click)="backBtn()"></i>
        </div> -->
        <div style="margin-left: 7%;">
            <h1 class="display-6" style="text-align: left;color: #ffc107;">
                DISCOVER OUR LATEST <span class="pink-color">REELS!</span>
            </h1>
        </div>

        <!-- <div class=" ">
           <img class=" " src="../../../../assets/pmbReelsFile/redLineIcn1.svg">
       </div> -->

    </div>
    <!--  -->

    <div class="horizontal-scroll-wrapper">
        <ng-container *ngFor="let item of assetArray">
            <div class="dv9">
                <!-- description  -->
                <!-- description  -->
                <div *ngIf="selectedDescriptionId == item?.id && selectedvideoid != item?.id" class="th11">

                    <div style="display: flex;justify-content: space-between;align-items: center;padding: 10px;">
                        <h3>{{item.title}}</h3>
                        <img (click)="showSelectedDesc()" src="../../../../assets/pmbReelsFile/navLIcn.svg"
                            style="border: 2px solid #ffc107; padding: 10px 15px; background-color: #413f3f; margin-top: -10px;">
                    </div>

                    <div style="font-size: 16px;padding: 10px;" [innerHTML]="item.description"> </div>
                </div>
                <!-- description  -->
                <!-- description  -->

                <!-- item  -->
                <!-- <ng-container></ng-container> -->
                <img *ngIf="selectedDescriptionId != item?.id && selectedvideoid != item?.id "
                    (click)="openMobileVideo(item?.id,item?.weburl)" class="th1" [src]="item.thumbnail" [id]="item.id"
                    [alt]="item?.alt">

                <div class="row dv12" *ngIf="selectedDescriptionId != item?.id && selectedvideoid != item?.id">
                    <div class="col-8 col-md-7">
                        <div (click)="showSelectedDesc(item.id)"
                            style="color: #f8f9fa;; font-size: 13px; font-weight: 500;">
                            <span> <i class="fa fa-angle-up" style="font-size: 1rem;"></i> &nbsp; </span>
                            Exporting Benefits
                        </div>
                    </div>
                    <div class="col-4 col-md-5 dv13">
                        <div class="dv5">
                            <img class="dv6" src="../../../../assets/pmbReelsFile/shareIcn.svg" data-toggle="modal"
                                (click)="share(item)" data-target="#shareModal">
                        </div>
                        <div class="dv4" (click)="scrollFunction('plus')">
                            <img class="" src="../../../../assets/pmbReelsFile/navRIcn.svg">
                        </div>
                    </div>
                </div>

                <div class="xpdv2" *ngIf="selectedvideoid == item.id && isMobileVideoOpen">
                    <video controls="controls" autoplay muted class="vd1" [title]="item?.videoDescription">
                        <source [src]="item.url" type="video/mp4">
                    </video>

                    <div class="row dv12">
                        <div class="col-8 col-md-7">
                            <div (click)="showSelectedDesc(item.id)"
                                style="color: #f8f9fa;; font-size: 13px; font-weight: 500;">
                                <span> <i class="fa fa-angle-up" style="font-size: 1rem;"></i> &nbsp; </span>
                                Exporting Benefits
                            </div>
                        </div>
                        <div class="col-4 col-md-5 dv13">
                            <div class="dv5">
                                <img class="dv6" src="../../../../assets/pmbReelsFile/shareIcn.svg" data-toggle="modal"
                                    (click)="share(item)" data-target="#shareModal">
                            </div>
                            <div class="dv4" (click)="scrollFunction('plus')">
                                <img class="" src="../../../../assets/pmbReelsFile/navRIcn.svg">
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <!-- item  -->
        </ng-container>
    </div>
</div>
<!-- mobile view -->


<!-- Modal -->
<div class="modal fade" id="shareModal" tabindex="-1" role="dialog" aria-labelledby="shareModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content fontFOCO">

            <div class="modal-body" style="padding: 4rem;background: #eee9e9;">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="font-size: 3rem;">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="brdr">
                    <div class="row text-left txtAll">
                        <div class="col-12">
                            <h4 class="text-muted">Share</h4>
                        </div>
                        <div class="col-12 my-2">
                            <h5 class="text-muted">Share this link via:</h5>
                        </div>
                        <div class="col-12 my-2"
                            style="display: flex;justify-content: flex-start;align-items: center;gap: 15px;font-size: 3rem;cursor: pointer;">
                            <i class="fa fa-facebook-official"></i>
                            <i class="fa fa-instagram"></i>
                            <i class="fa fa-linkedin-square"></i>
                            <i class="fa fa-twitter-square"></i>
                            <i class="fa fa-xing-square"></i>
                            <i class="fa fa-whatsapp"></i>
                        </div>
                        <div class="col-12 my-2">
                            <h5>Or copy link:</h5>
                        </div>
                        <div class="col-12 my-2">
                            <input readonly type="text" class="text-muted"
                                [value]="'https://www.pikmybox.com/video-resources'+selectedItem?.weburl" #userinput
                                style="width: 100%;
                            border: none;
                            border-bottom: 2px solid #FCC000;
                            background: white;
                            font-size: large;">
                        </div>
                        <div class="col-12 my-2">
                            <button class="text-muted" (click)="copyInputMessage(userinput)" style="width: 50%;
                            color: black !important;
                            background: #FCC000;
                            font-size: 1.3rem;
                            padding: 10px;
                            border: none;
                            margin: 0;">
                                <i class="fa fa-plus" aria-hidden="true" style="font-size: 1rem;"></i> &nbsp; Copy link
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>